import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from "@mui/material";
import { useState, useEffect } from "react";
import { AUTHENTICATED_EMPLOYEE_JWT } from "../../constants";
import { jwtDecode, JwtPayload } from "jwt-decode";

interface UpdatePasswordDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (passwordData: { currentPassword: string; newPassword: string }) => void;
}

interface CustomJwtPayload extends JwtPayload {
  password?: string;
}

export const UpdatePasswordDialogBox = ({ open, onClose, onSubmit }: UpdatePasswordDialogProps) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<boolean>(false);
  let currentPassword: string | undefined;

  if (location.pathname !== "/login" && location.pathname !== "/") {
    const token = localStorage.getItem(AUTHENTICATED_EMPLOYEE_JWT);
    if (token) {
      const decodedToken = jwtDecode(token) as CustomJwtPayload;
      currentPassword = decodedToken?.password;
    }
  }

  useEffect(() => {
    if (!open) {
      setNewPassword("");
      setConfirmPassword("");
      setError(false);
    }
  }, [open]);

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setError(e.target.value !== newPassword);
  };

  const handleSubmit = () => {
    if (newPassword !== confirmPassword) {
      setError(true);
      return;
    }

    if (!currentPassword) {
      console.error("Current password is missing.");
      return;
    }

    onSubmit({ currentPassword, newPassword });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Update Password</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="New Password"
          type="password"
          fullWidth
          variant="outlined"
          value={newPassword}
          onChange={(e) => handleNewPasswordChange(e)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          margin="dense"
          label="Confirm New Password"
          type="text  "
          fullWidth
          variant="outlined"
          value={confirmPassword}
          onChange={(e) => handleConfirmPasswordChange(e)}
          sx={{ marginBottom: 2 }}
          error={error}
          helperText={error ? "Passwords do not match New Password" : ""}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={!newPassword || !confirmPassword || error}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
